module.exports = __webpack_public_path__ + "img/512.37f13d9.png";